/** «Чаты Bitrix» — ровно то, что отдают `GET /api/bitrix/chats/*`. */
import { apiFetch, query } from "@/lib/api";

export type ChatCounts = {
  sessions: number;
  client: number;
  operator: number;
  lead: number;
  deal: number;
  no_crm: number;
  unanswered: number;
};

/** Реакция оператора в секундах рабочего времени 10:00–21:00; null — ответов не было. */
export type Reaction = { first_reaction: number | null; reaction: number | null; replies: number };

export type ChatSource = ChatCounts & Reaction & { source: string; channel: string };

export type ChatOperator = Reaction & { name: string; sessions: number };

export type ChatSession = {
  id: number;
  date: string;
  source: string;
  channel: string;
  client_name: string;
  operator_name: string;
  bitrix_user_id: number | null;
  status: string;
  crm_type: string;
  crm_id: number | null;
  /** Статус лида / стадия сделки сейчас (CRM). */
  crm_status: string | null;
  client_msgs: number;
  operator_msgs: number;
  wait_answer: number | null;
  answered: boolean;
  fetched: boolean;
  /** Обращений клиента без ответа. */
  unreplied: number;
  messages: ChatMessage[];
} & Reaction;

export type ChatsReport = {
  from: string;
  to: string;
  source: string | null;
  totals: ChatCounts & Reaction;
  sources: ChatSource[];
  operators: ChatOperator[];
  sessions: ChatSession[];
  synced_at: string | null;
};

/** `reaction` — у ответа оператора на обращение клиента: сколько рабочих секунд ждали. */
export type ChatMessage = { id: number; date: string; author: "client" | "operator" | "system"; name: string; text: string; reaction?: number };

export type ChatDialog = {
  id: number;
  date: string;
  source: string;
  channel: string;
  client_name: string;
  status: string;
  crm_type: string;
  crm_id: number | null;
  messages: ChatMessage[];
};

export function loadChats(p: { from: string; to: string; source?: string }): Promise<ChatsReport> {
  return apiFetch<ChatsReport>(`/api/bitrix/chats/report${query(p)}`);
}

export function loadDialog(id: number): Promise<ChatDialog> {
  return apiFetch<ChatDialog>(`/api/bitrix/chats/${id}`);
}

const iso = (d: Date) => d.toLocaleDateString("sv-SE");

/** Последние 7 дней, сегодня включительно — как у сервера по умолчанию. */
export function lastDays(n = 7): { from: string; to: string } {
  const b = new Date();
  const a = new Date(b);
  a.setDate(a.getDate() - (n - 1));
  return { from: iso(a), to: iso(b) };
}

export const STATUS: Record<string, string> = {
  new: "новый",
  answered: "в работе",
  closed: "закрыт",
  spam: "спам",
  paused: "пауза",
};

/** Реакция коротко: «< 1 мин», «12 мин», «2 ч 05 мин». */
export function fmtReaction(sec: number | null | undefined): string {
  if (sec == null) return "—";
  const m = Math.round(sec / 60);
  if (m < 1) return "< 1 мин";
  if (m < 60) return `${m} мин`;
  return `${Math.floor(m / 60)} ч ${String(m % 60).padStart(2, "0")} мин`;
}
